export const productCategories = [
  'Reiniging',
  'Reinigingstools',
  'Oliën',
  'Bloemen & water',
  'Schoonheid',
  'Geur',
] as const

export const products = [
  {
    name: 'Savon Beldi',
    alias: 'Savon Noir · Zwarte zeep',
    category: 'Reiniging',
    what: 'Een traditionele Marokkaanse zeep in de vorm van een zachte, rijke pasta, gemaakt op basis van olijf en een alkalisch verzepingsmiddel.',
    use: 'Breng aan op de warme, vochtige huid als voorbereidende stap vóór het scrubben met de Kessa.',
  },
  {
    name: 'Ghassoul',
    alias: 'Rhassoul-klei',
    category: 'Reiniging',
    what: 'Een natuurlijke minerale klei uit de Moulouya-vallei, rijk aan magnesiumhoudende kleimineralen van de stevensietgroep.',
    use: 'Meng met water tot een kleipasta en gebruik als reinigende behandeling voor huid en haar.',
  },
  {
    name: 'Nila',
    alias: 'Nila Sahraouia',
    category: 'Reiniging',
    what: 'Een fijn, diepblauw poeder afkomstig uit de Sahara.',
    use: 'Meng tot een zachte pasta en breng als masker aan op de gezuiverde huid.',
  },
  {
    name: 'Tbrima',
    alias: 'Kruidenpoeder',
    category: 'Reiniging',
    what: 'Een kruidenpoeder van fijngemalen planten en natuurlijke poeders, met een eigen geselecteerd kruidenmengsel.',
    use: 'Meng met water of rozenwater tot een zachte pasta en breng aan op een vochtige huid.',
  },
  {
    name: 'Kessa',
    alias: 'Exfoliërende handschoen',
    category: 'Reinigingstools',
    what: 'Een handschoen met een stevige, geweven textuur die oppervlakkige dode huidcellen en schilfers losmaakt.',
    use: 'Scrub de huid na de Savon Beldi voor een gladdere, zachtere huid.',
  },
  {
    name: "M'hekka",
    alias: 'Voetsteen',
    category: 'Reinigingstools',
    what: 'Voor het verzorgen van ruwe en verharde huid.',
    use: 'Vooral voor voeten, hielen, knieën en ellebogen.',
  },
  {
    name: 'Arganolie',
    alias: 'Uit de vrucht van de arganboom',
    category: 'Oliën',
    what: 'Een plantaardige olie met oliezuur en linolzuur, rijk aan tocoferolen.',
    use: 'Verzacht en verzorgt het haar, houdt de huid soepel en ondersteunt het vasthouden van vocht.',
  },
  {
    name: 'Cactusvijgolie',
    alias: 'Prickly pear seed oil',
    category: 'Oliën',
    what: 'Olie uit de vrucht van de Opuntia ficus-indica, met een zeer hoog percentage linolzuur, plus tocoferolen en fytosterolen.',
    use: 'Als gezichtsolie tegen een trekkerig gevoel; maakt de huid glad en soepel en helpt de huidbarrière te behouden.',
  },
  {
    name: 'Rozenwater',
    alias: 'Damascusroos',
    category: 'Bloemen & water',
    what: 'Aromatisch bloemenwater, gedistilleerd uit blaadjes van de Damascusroos, met antioxidatieve eigenschappen.',
    use: 'Als toner of verfrissende mist. Laat geen olieachtige laag achter.',
  },
  {
    name: 'Oranjebloesemwater',
    alias: 'Bittere sinaasappelbloesem',
    category: 'Bloemen & water',
    what: 'Bloemenwater uit stoomdestillatie van de bloesems van de bittere sinaasappelboom.',
    use: 'Als gezichtsmist of toner na het reinigen. Laat geen vettige laag achter.',
  },
  {
    name: 'Rozenblaadjes',
    alias: 'Gedroogde Damascusroos',
    category: 'Bloemen & water',
    what: 'Gedroogde bloemblaadjes met polyfenolen, flavonoïden en natuurlijke kleurstoffen zoals anthocyanen.',
    use: 'Voeg toe aan warm badwater, of maal fijn en combineer met ghassoul voor een gezichtsmasker.',
  },
  {
    name: 'Aker Fassi',
    alias: 'Natuurlijk pigment',
    category: 'Schoonheid',
    what: 'Fijngemalen gedroogde rode klaproosblaadjes en granaatappelschil: een sterk gepigmenteerd poeder.',
    use: 'Activeer met water of rozenwater en geef wangen en lippen een rode of roze tint.',
  },
  {
    name: 'Kohl',
    alias: 'Oogcosmeticum',
    category: 'Schoonheid',
    what: 'Een natuurlijk oogcosmeticum voor het omlijnen van de ogen.',
    use: 'Geeft zwarte of donkergrijze lijnen.',
  },
  {
    name: 'Henna Sidr',
    alias: 'Plantaardige haarverzorging',
    category: 'Schoonheid',
    what: 'Haarverzorging op basis van henna en sidr. Het kleurende bestanddeel lawsone reageert met keratine.',
    use: 'Breng aan op het haar voor een langdurige hennakleur en verzorging.',
  },
  {
    name: 'Musk',
    alias: 'Warm & zacht',
    category: 'Geur',
    what: 'Een warme, zachte en langdurige geur die subtiel op de huid blijft hangen.',
    use: 'Een kleine hoeveelheid op polsen, hals of achter de oren. Ontwikkelt zich gedurende de dag.',
  },
  {
    name: 'Oud',
    alias: 'Diep & houtachtig',
    category: 'Geur',
    what: 'Een diepe, warme en houtachtige geur met een rijk en langdurig karakter.',
    use: 'Een kleine hoeveelheid op polsen, hals of achter de oren. Ontwikkelt zich geleidelijk op de huid.',
  },
]
